import React from 'react';
import { IUserAssociatedProperty } from '../../types';
import {
  IUseKeyPickupInvite,
  useKeyPickupInvite,
} from '../../CustomHooks/useKeyPickupInvite/useKeyPickupInvite';
import KeyPickupInviteForm from './KeyPickupInviteForm';
import KeyPickupInviteConfirmation from './KeyPickupInviteConfirmation';

interface KeyPickupInviteDialogProps {
  property: IUserAssociatedProperty;
  onClose: () => void;
}

const KeyPickupInviteDialog = ({
  property,
  onClose,
}: KeyPickupInviteDialogProps) => {
  const invite: IUseKeyPickupInvite = useKeyPickupInvite(property.propertyId);

  if (invite.inviteResult) {
    return (
      <KeyPickupInviteConfirmation
        propertyId={property.propertyId}
        invitedUnits={invite.inviteResult.invitedUnits}
        onClose={onClose}
      />
    );
  }

  return (
    <KeyPickupInviteForm
      property={property}
      onClose={onClose}
      units={invite.units}
      isLoadingUnits={invite.isLoadingUnits}
      unitsError={invite.unitsError}
      selectedUnitIds={invite.selectedUnitIds}
      toggleUnit={invite.toggleUnit}
      selectAllEligible={invite.selectAllEligible}
      deselectAll={invite.deselectAll}
      eligibleCount={invite.eligibleCount}
      selectedBookingLinkId={invite.selectedBookingLinkId}
      selectBookingLink={invite.selectBookingLink}
      isSubmitting={invite.isSubmitting}
      submitError={invite.submitError}
      submit={invite.submit}
    />
  );
};

export default KeyPickupInviteDialog;